const REDACTED = '[redacted]';

export function isSensitiveKey(key: string): boolean {
  const name = key.toLowerCase().replace(/_/g, '');
  return (
    name.startsWith('ssn') ||
    name.includes('socialsecurity') ||
    name.includes('dateofbirth') ||
    name.includes('birthdate') ||
    name === 'dob'
  );
}

function redactString(value: string): string {
  const trimmed = value.trimStart();
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) return value;
  try {
    return JSON.stringify(redactSensitive(JSON.parse(value)));
  } catch {
    return value;
  }
}

export function redactSensitive(value: unknown): unknown {
  if (typeof value === 'string') return redactString(value);
  if (Array.isArray(value)) return value.map(redactSensitive);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [
        key,
        isSensitiveKey(key) && entry != null && entry !== ''
          ? REDACTED
          : redactSensitive(entry),
      ])
    );
  }
  return value;
}

export function withoutSensitive<T>(record: T): T {
  if (!record || typeof record !== 'object') return record;
  return Object.fromEntries(
    Object.entries(record).map(([key, value]) => [
      key,
      isSensitiveKey(key) && value != null ? '' : value,
    ])
  ) as T;
}
